// utils
import { addAllValue } from 'src/utils/v5/DataTrees'

export const REPORT_CARE_PLAN_DEFAULT_SORT = {
  sortedColumn: 'patient.fullName',
  sortedColumnOrder: 'ascend'
}

export const REPORT_CARE_PLAN_FILTER_BY = [
  {
    key: 0,
    title: 'Goals',
    value: 'goal'
  },
  {
    key: 1,
    title: 'Interventions',
    value: 'intervention'
  }
]

export const CARE_PLAN_TYPES_WITH_ALL = addAllValue({
  list: REPORT_CARE_PLAN_FILTER_BY
})

export const REPORT_CARE_PLAN_MAX_WORD_LENGTH = 25
